export default emailConfigs => emailConfigs.map((emailConfig) => {
  const formattedEmail = `${emailConfig.sender_name || ''} (${emailConfig.email})`;
  return { id: emailConfig.id, formattedEmail, is_primary: emailConfig.is_primary };
});
